import { createContext } from 'react'

export const LoginContex = createContext();